// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__27R0_","col":"CardReaderDesc_col__3OxU9","label":"CardReaderDesc_label__KGk8h"};